module.exports = __webpack_public_path__ + "img/logo.ac76b27a.png";